/**
 * AgentsProcureRpcClient — AtomRpc integration for the customer-facing,
 * authenticated agent-procurement endpoints (`agents.procureQuote` /
 * `agents.procure` / `agents.confirmProcure` / `agents.installHandle`, CLA-605).
 *
 * Powers the dashboard "Add Agent" wizard: a signed-in customer procures
 * another agent themselves (configure → price → pay on the saved card →
 * provision). The backend resolves the caller's customer from `CurrentActor`;
 * this client just carries the Clerk session token, mirroring
 * `InstallationRpcClient` / `OnboardingRpcClient` verbatim.
 *
 * @since 1.0.0
 */
import { AtomRpc } from "@effect-atom/atom-react";
import { FetchHttpClient } from "@effect/platform";
import { RpcSerialization } from "@effect/rpc";
import { AgentsProcureRpcs } from "@fm/api/rpc";
import { Layer } from "effect";
import { makeRpcClientLayer, makeTokenGetterLayer } from "./shared.ts";

export class AgentsProcureRpcClient extends AtomRpc.Tag<AgentsProcureRpcClient>()(
  "AgentsProcureRpcClient",
  {
    group: AgentsProcureRpcs,
    protocol: makeRpcClientLayer(AgentsProcureRpcs).pipe(
      Layer.provide(RpcSerialization.layerNdjson),
      Layer.provide(makeTokenGetterLayer()),
      Layer.provide(FetchHttpClient.layer),
    ),
  },
) {}
